import React from 'react';
import { useTranslation } from 'react-i18next';
import { Container, Row } from 'reactstrap';
import styled from 'styled-components';
import LanguageToggle from '../../modules/login/LanguageToggle';
import { GET_APP_URL } from '../../config';
import { BORDER_GREY_COLOR } from '../../shared/styles/Colors';

const menu = [
  { text: 'privacy_policy', path: GET_APP_URL + '/privacy-policy' },
  { text: 'cookie_policy', path: GET_APP_URL + '/cookie-policy' },
  { text: 'security', path: GET_APP_URL + '/security' },
  { text: 'status', path: 'https://bizapp.statuspage.io/' },
  { text: 'change_language', path: '', isLanguage: true },
];

const Footer = () => {
  const { t } = useTranslation();

  return (
    <StyledFooter
      className='mt-auto py-4'
      style={{ borderTop: `1px solid ${BORDER_GREY_COLOR}` }}
    >
      <Container fluid>
        <Row>
          <div className='col-12 col-md-5 text-center text-md-left'>
            {menu.map((value, key) =>
              !value.isLanguage ? (
                <LinkWrapper
                  href={value.path}
                  target='_blank'
                  key={key}
                  className='text-700'
                >
                  {t(value.text)}
                </LinkWrapper>
              ) : (
                <LanguageWrapper key={key}>
                  <LanguageToggle login={false} />
                </LanguageWrapper>
              )
            )}
          </div>

          <div className='col-12 col-md-4 mt-3 mt-md-0 text-center text-md-left'>
            <span className='text-muted'>© Copyright 2023, Biz, Qatar</span>
          </div>
        </Row>
      </Container>
    </StyledFooter>
  );
};

export default Footer;

const LinkWrapper = styled.a`
  cursor: pointer;
  color: #010101;
  margin: 0.5rem 1rem;
  display: inline-flex;
  align-items: center;
  flex-direction: row;
  :hover {
    span {
      color: black;
    }
  }
`;

const LanguageWrapper = styled.div`
  font-weight: 400;
  text-decoration: none;
  cursor: pointer;
  color: #010101;
  display: inline-flex;
`;

const StyledFooter = styled.footer`
  background-color: #fff9f7;
`;
